import React, { useMemo, useState } from 'react';
import { useNotificationsQuery } from '../gql/hooks/queries/useNotificationsQuery';

export const NotificationContext = React.createContext( [] );

export function NotificationProvider( { children } ) {

    const { data, loading, markNotificationRead } = useNotificationsQuery();

    const [ locallyRead, setLocallyRead ] = useState( [] );

    // list of featured notificaitons that show up on login
    const featuredNotifications = useMemo( () => {
        if ( !data ) {return [];}

        /**
         * order is [sticky -> featured]
         * sticky order is [low weight -> high weight] with suborder of [oldest date -> latest date]
         * featured order is [oldest date -> latest date]
         * 
         * sample order
         * [sticky wt = 0, sticky wt = 3, sticky wt = 4, feat t = oldest, feat t = old, feat t = newest]
         */

        const stickyNotis = data
            .filter( n => !n.isRead && n.isSticky )
            .sort( ( a, b ) => new Date( a.publishedAt ) - new Date( b.publishedAt ) )
            .sort( ( a, b ) => a.weight - b.weight );

        const nonStickyNotis = data
            .filter( n => !n.isRead && n.isFeatured && !n.isSticky ) 
            .sort( ( a, b ) => new Date( a.publishedAt ) - new Date( b.publishedAt ) );

        return [ ...stickyNotis, ...nonStickyNotis ];

    }, [ data ] );

    // list of all notificaitons that are used for dropdown and dropdown carousel navigation
    const notifications = useMemo( () => {
        if ( !data ) {return [];}

        return data
            .map( n => ( { ...n, isRead: n.isRead || locallyRead.includes( n.id ) } ) )
            .sort( ( a, b ) => new Date( b.publishedAt ) - new Date( a.publishedAt ) );
    }, [ data, locallyRead ] );

    function readNotification( id ) {
        // try to read notification. if it has been read (lcoally or originally) this does nothing
        if ( locallyRead.includes( id ) || !id || data.find( n => n.id == id ).isRead ) {
            return;
        }
        setLocallyRead( [ ...locallyRead, id ] );
        markNotificationRead( id );
    }

    return <NotificationContext.Provider value={ { notifications, featuredNotifications, readNotification, loading } }>{ children }</NotificationContext.Provider>;
}
